import themeOptions from './themeOptions';

const luzmoStyles = {
  loaderBackground: 'transparent',
  loaderFontColor: themeOptions.palette.text.primary,
  loaderSpinnerBackground: 'transparent',
  loaderSpinnerColor: (themeOptions.palette.secondary as { light: string })
    .light,
  mainColor: (themeOptions.palette.secondary as { light: string }).light,
};

export default luzmoStyles;
